import { productCardStyles as styles } from "@solveindustrial/Overrides/Widgets/ProductList/ProductListProductCard";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.gridContainer = {
    ...styles.gridContainer,
    gap: 0,
    css: css`
        ${styles.gridContainer?.css}
        padding: 16px;
    `,
    offsetCss: css`
        ${styles.gridContainer?.offsetCss}
        gap: 16px;

        flex-wrap: nowrap !important;
    `,
};

styles.leftColumnGridItem = {
    ...styles.leftColumnGridItem,
    css: css`
        ${styles.leftColumnGridItem?.css}
        padding: 0;
    `,
};

styles.rightColumnGridContainer = {
    ...styles.rightColumnGridContainer,
    gap: 0,
    css: css`
        ${styles.rightColumnGridContainer?.css}
        padding: 0;
        height: 100%;
    `,
    offsetCss: css`
        ${styles.rightColumnGridContainer?.offsetCss}
        gap: 16px;
        justify-content: space-between;

        height: 100%;
        ${mediaQueriesBP.minMD} {
            flex-wrap: nowrap !important;
        }
    `,
};

styles.infoGridItem = {
    ...styles.infoGridItem,
    css: css`
        ${styles.infoGridItem?.css}
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};
